"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRegisterFieldsByCountry = void 0;
/* eslint-disable no-console */
const firestore_1 = require("@react-query-firebase/firestore");
const firestore_2 = require("firebase/firestore");
const keyFactory_1 = require("../keyFactory");
/**
 *
 * @returns Devuelve los campos dinamicos que le mostramos a cada país en el signup
 */
/**
 *
 * @param firestore
 * @param country
 */
function useRegisterFieldsByCountry(firestore, country) {
    const registerRef = (0, firestore_2.collection)(firestore, `parametros/${country}/signup`);
    const registerActiveQuery = (0, firestore_2.query)(registerRef, (0, firestore_2.orderBy)("order", "asc"));
    return (0, firestore_1.useFirestoreQueryData)(keyFactory_1.FirestoreKeys.WithoutCategory({
        name: "fieldsByCountry",
        path: `parametros/${country}/signup`
    }, [country]), registerActiveQuery, {}, {
        select: (data) => {
            if (data)
                return data;
            else
                console.error(`Error en los campos de signup de ${country}`);
        },
    });
}
exports.useRegisterFieldsByCountry = useRegisterFieldsByCountry;
